import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { routes } from 'src/constants/routes';
import { PathNames } from 'src/shared/enum/PathNames';
import { getStorage } from 'src/utils/local-storage-versioning';
import { useHandleUserAuth } from 'src/utils/handle-user-auth';

import { auth0 } from '../../auth/constants';

interface CallbackPageProps {
    isAmendCallback?: boolean;
    isDualOccupantAmendCallback?: boolean;
}

export const CallbackPage: FC<CallbackPageProps> = ({
    isAmendCallback = false,
    isDualOccupantAmendCallback = false,
}) => {
    const navigate = useNavigate();
    const localStorage = getStorage();
    const { handleUserAuth } = useHandleUserAuth();
    const storage = getStorage();
    const { amend } = storage;

    useEffect(() => {
        const checkUserLoggedIn = async () => {
            auth0.parseHash(async (err, authResult) => {
                if (err) {
                    navigate(routes.summary.index);
                    return;
                }

                if (authResult && authResult.idToken && authResult.idTokenPayload) {
                    await handleUserAuth(authResult);

                    if (isAmendCallback) {
                        navigate(`${routes.amendBooking.index}?vitaRef=${amend.vitaRef}`);
                        return;
                    }

                    if (isDualOccupantAmendCallback) {
                        navigate(`${routes.amendBooking.dualOccupant}?vitaRef=${amend.vitaRef}`);
                    }

                    const navigateToBookingDetails =
                        (localStorage.navigationState.page as PathNames) ===
                        PathNames.BOOKING_DETAILS;
                    navigate(
                        navigateToBookingDetails
                            ? routes.bookingDetails.index
                            : routes.summary.index
                    );
                } else {
                    navigate(routes.summary.index);
                }
            });
        };
        checkUserLoggedIn();
    }, [navigate]);

    return null;
};
